// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Offer48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Offer48: FC<Offer48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M22.313 44c-.375 0-.75-.07-1.125-.212a3.016 3.016 0 0 1-1.013-.638L4.875 27.8a2.506 2.506 0 0 1-.675-.975 3.105 3.105 0 0 1-.225-1.137c0-.375.072-.75.215-1.125.144-.375.372-.713.685-1.013L23.525 4.9a3.14 3.14 0 0 1 .98-.657A2.93 2.93 0 0 1 25.675 4h15.35a2.89 2.89 0 0 1 2.119.881A2.89 2.89 0 0 1 44.025 7v15.3c0 .403-.083.787-.25 1.152a3.211 3.211 0 0 1-.65.948l-18.7 18.75c-.3.267-.633.475-1 .625-.367.15-.738.225-1.113.225Zm-.088-2.9 18.8-18.9V7h-15.35L6.925 25.75l15.3 15.35Zm13.55-26.3c.7 0 1.308-.258 1.825-.775.517-.517.775-1.125.775-1.825s-.258-1.308-.775-1.825c-.517-.517-1.125-.775-1.825-.775s-1.308.258-1.825.775c-.517.517-.775 1.125-.775 1.825s.258 1.308.775 1.825c.517.517 1.125.775 1.825.775Z" />
        </svg>
    );
};

export default Offer48;
